/* global $ */

class WorksContent {
    constructor() {
        this.$container = $('.Content');
        this.separatorNum = this.$container.find('.wp-block-section').length;
        this.$sections = [];

        for(let i = 0; i < this.separatorNum + 1; i++) {
            let setColor = 'white';
            if(i > 0) {
                if($(this.$container.find('.wp-block-section')[i - 1]).attr('data-color') != undefined) {
                    setColor = $(this.$container.find('.wp-block-section')[i - 1]).attr('data-color');
                }
            }
            this.$sections.push($(`<div class="Content__section" data-color="${setColor}"></div>`));
        }

        let sectionCount = 0;
        this.$container.children('*').each((i, e) => {
            if($(e).attr('class') == undefined || ($(e).attr('class') != undefined && !$(e).hasClass('wp-block-section'))) {
                this.$sections[sectionCount].append($(e));
            } else {
                $(e).remove();
                sectionCount++;
            }
        });

        this.$container.append(this.$sections);

    }
}

export default WorksContent;